<div class="content-header">Activity</div>
<div class="content-with-elevation content" style="margin-top: 16px;">
  <div class="grid-x">
    <div class="cell large-12 small-12 medium-12" *ngFor="let log of auditLog">
      <lib-audit-log-individual-section [auditLog]="log"  [tldName]="domainName"></lib-audit-log-individual-section>
    </div>
  </div>
</div>

